import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService, AppConfig } from '../../../_helpers/index';
import { Router } from '@angular/router';
import { AccountImport } from '../../../_models';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
type AOA = any[][];
import { ConfigurationService, ProcessService } from '../../../_services';
import * as Excel from "exceljs/dist/exceljs.min.js";
import { Observable } from 'rxjs';

@Component({
  selector: 'app-old-payout-invoice-import-version',
  templateUrl: './old-payout-invoice-import-version.component.html',
  styleUrls: ['./old-payout-invoice-import-version.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class OldPayoutInvoiceImportVersionComponent implements OnInit  {
  uploadedFileName: any;
  tab1ActiveStatus: any;
  tab2ActiveStatus: any;
  tab3ActiveStatus: any;
  tab1Visibility: any;
  tab2Visibility: any;
  tab3Visibility: any;
  enableImportExcel: boolean;
  customerPuplic_key: any;
  user_public_id: any;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  userNameProcess: string;
  userEmail: string;
  searchFilterForm: FormGroup;
  configData: any;
  templateName: any;
  data: any;
  errorImport: string;
  excelheaderFormat = ["ID CLIENTE", "DOCUMENTO", "NUMERO DOCUMENTO", "NOMBRE", "EMAIL", "TELEFONO", "ESTADO", "ID ORDEN DE PAGO",
     "REFERENCIA", "NOMBRE ORDEN", "DESCRIPCION", "MONEDA", "MONTO", "VENCIMIENTO", "EXPIRACION", "CODIGO BANCO", "CUENTA", "TIPO DE CUENTA", "CCI"]
  excelHeader: any;
  isExcelReadError = false;
  excelReadError: any;
  excelRowsFetchedCount: any;
  excelRowsProcessedCount: any;
  excelRowsNotProcessedCount: any;
  public arrFinalData = [];
  dataSource: any;
  invalidDataArray: any;
  invalidDataSource: any;
  pageSize: number;
  PageSizeOptions: number[];
  obsInvalidData: Observable<any>;
  displayedColumns: string[] = ['item','client_id', 'document', 'document_number', 'name', 'email', 'telephone', 'status',
  'payment_order_id', 'reference', 'order_name', 'description', 'currency', 'amount', 'vencimiento', 'expiration',
  'bank_code', 'bill', 'account_type','cci'];
  formData: FormData = new FormData();
  @ViewChild('kashioPaginator', { read: MatPaginator }) kashioPaginator: MatPaginator;
  @ViewChild('kashioPaginator1', { read: MatPaginator }) kashioPaginator1: MatPaginator;
  parseID: any;
  ProcessTitle: string;
  ProcessSubTitle: string;
  tab3Error: boolean;
  columnErrorCount = 0;
  rowErrorCount = 0;
  excelAvailableColumn = [];
  missingExcelColumns = [];
  excelInvalidColumn = [];
  excelInvalidColumnLetter = [];
  hiddenRow = [];
  hiddenRowCount = 0;
  hiddenColumn = [];
  hiddenColumnCount = 0;
  keyValuesChange = {
    'ITEM': 'ITEM',
    'ID CLIENTE' : 'CLIENT_ID',
    'DOCUMENTO': 'DOCUMENT',
    'NUMERO DOCUMENTO': 'DOCUMENT_NUMBER',
    'NOMBRE': 'NAME',
    'EMAIL': 'EMAIL',
    'TELEFONO': 'TELEPHONE',
    'ESTADO': 'STATUS',
    'ID ORDEN DE PAGO':'PAYMENT_ORDER_ID',
    'REFERENCIA':'REFERENCE',
    'NOMBRE ORDEN':'ORDER_NAME',
    'DESCRIPCION': 'DESCRIPTION',
    'MONEDA': 'CURRENCY',
    'MONTO': 'AMOUNT',
    'VENCIMIENTO': 'VENCIMIENTO',
    'EXPIRACION': 'EXPIRATION',
    'CODIGO BANCO': 'BANK_CODE',
    'CUENTA': 'BILL',
    'TIPO DE CUENTA': 'ACCOUNT_TYPE',
    'CCI': 'CCI'
  };
  keyChangedData = [];
  excelColumnNameAndLetter = [];
  allowedDateFormats = ['DD/MM/YYYY', 'D/M/YYYY', 'DD/MM/YY', 'D/M/YY'];
  tempExcelHeader = [];
  constructor(private router: Router, private formBuilder: FormBuilder
    , private spinnerService: Ng4LoadingSpinnerService
    , private configurationService: ConfigurationService
    , private processservice: ProcessService
    , private excelService: ExcelService) {
      this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
      this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
  }

  ngOnInit() {

    var tempBrowserStorage;

    // let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    // if (browserStorage1 == null) {
    //   let browserStorage = localStorage.getItem('companyId');
    //   if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
    //     this.router.navigate(['/home']);
    //   }
    //   else {
    //     this.customerPuplic_key = localStorage.getItem('companyId');
    //     this.user_public_id = localStorage.getItem('userId');
    //     this.userNameProcess = localStorage.getItem('username');
    //     this.userEmail = localStorage.getItem('userEmail');
    //   }
    // }
    // else {
    //   this.customerPuplic_key = localStorage.getItem('subcompanyId');
    //   this.user_public_id = localStorage.getItem('userId');
    // }
    if (
      (localStorage.getItem('companyId') != null || localStorage.getItem('companyId') != '' || localStorage.getItem('companyId') != undefined)
      &&
      (localStorage.getItem('application') != null || localStorage.getItem('application') != '' || localStorage.getItem('application') != undefined)) {
      if (localStorage.getItem('isCorporate') == 'Yes') {
        this.customerPuplic_key = localStorage.getItem('subcompanyId');
      } else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
      this.user_public_id = localStorage.getItem('userId');
      this.userNameProcess = localStorage.getItem('username');
      this.userEmail = localStorage.getItem('userEmail');
    }
    else {
      this.router.navigate(['/home']);
    }
    
    tempBrowserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof tempBrowserStorage.getItem('timezone') === 'undefined') ? null : tempBrowserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {

      this.offsetTimeZone = tempBrowserStorage.getItem('timezone');
      this.offsetMinutes = 0;

      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    this.Init();
    this.GetConfigList();
  }

  ngAfterViewInit() {
    this.kashioPaginator._intl.itemsPerPageLabel = "Registros por página";
    this.kashioPaginator._intl.nextPageLabel = "siguiente página";
    this.kashioPaginator._intl.lastPageLabel = "última página";
    this.kashioPaginator._intl.previousPageLabel = "anterior página";
    this.kashioPaginator._intl.firstPageLabel = "primera página";

    this.kashioPaginator1._intl.itemsPerPageLabel = "Registros por página";
    this.kashioPaginator1._intl.nextPageLabel = "siguiente página";
    this.kashioPaginator1._intl.lastPageLabel = "última página";
    this.kashioPaginator1._intl.previousPageLabel = "anterior página";
    this.kashioPaginator1._intl.firstPageLabel = "primera página";
  }

  Init(){
    this.tab1();
    this.excelRowsFetchedCount = Number(0);
    this.excelRowsProcessedCount = Number(0);
    this.excelRowsNotProcessedCount = Number(0);
    this.dataSource = new MatTableDataSource();
    this.data = [];
    this.keyChangedData = [];
    this.arrFinalData = [];
    this.isExcelReadError = false;
    this.excelReadError = '';
    this.invalidDataArray = [];
    this.invalidDataSource = new MatTableDataSource();
    this.tab3Error =false;
    this.columnErrorCount = 0;
    this.rowErrorCount = 0;
    this.excelAvailableColumn = [];
    this.missingExcelColumns = [];
    this.hiddenRow = [];
    this.hiddenRowCount = 0;
    this.hiddenColumn = [];
    this.hiddenColumnCount = 0;
    this.excelInvalidColumn = [];
    this.excelColumnNameAndLetter = [];
    this.excelInvalidColumnLetter =[];
    this.tempExcelHeader = [];
    this.excelHeader = [];
  }

  tab1(){
    this.searchFilterForm = this.formBuilder.group({
      edt: ['']
    });
    this.enableImportExcel = false;
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = false;
    this.tab2Visibility = true;
    this.tab3Visibility = true;
    this.uploadedFileName = "Archivo a subir";
    window.scroll(0,0);
  }

  tab2() {
      this.tab1Visibility = true;
      this.tab2Visibility = false;
      this.tab3Visibility = true;
      this.tab1ActiveStatus = "disabled";
      this.tab2ActiveStatus = "active";
      this.tab3ActiveStatus = "disabled";
      window.scroll(0,0);
  }

  tab3(){
      this.tab1Visibility = true;
      this.tab2Visibility = true;
      this.tab3Visibility = false;
      this.tab1ActiveStatus = "disabled";
      this.tab2ActiveStatus = "disabled";
      this.tab3ActiveStatus = "active";
      window.scroll(0,0);
  }

  Executeagain() {
    this.Init();
  }

  GetConfigList() {
    this.configurationService.getConfigurationList(this.customerPuplic_key, 'KBATCH').subscribe(data => {
      this.configData = data["data"];
      if (this.configData.length != 0) {
        this.templateName = this.configData[0].values.value;
      }
    },
      error => {
        console.log('Failed! while trying to get the acccount details list. ' + error);
      });
  }
  Init1(){
    this.excelColumnNameAndLetter = [];
    this.data = [];
    this.uploadedFileName = '';
    this.enableImportExcel = false;
    this.hiddenRow = [];
    this.hiddenRowCount = 0;
    this.hiddenColumn = [];
    this.hiddenColumnCount = 0;
  }

  onFileChange(evt: any) {
    this.Init1();
    let jsonData = null;
    let workBook = null;
    let sheet = [];
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length > 1) throw new Error('Cannot use multiple files');
    if (target.files.length === 1) {
      this.checkHiddenRowAndColumns(target.files[0]);
      const file = target.files[0];
      this.searchFilterForm.get('edt').setValue(file);
      this.uploadedFileName = target.files[0].name;

      if (target.files.length == 1 && (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary',cellText:false ,cellDates:true});
          jsonData = workBook.SheetNames.reduce((initial, name) => {
            const sheet = workBook.Sheets[name];
            initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: null, raw: false, blankrows:false, dateNF:'DD/MM/YYYY' });
            return initial;
          }, {});
          var sheet = Object.keys(jsonData);
          if(sheet.length > 0){
            this.data = jsonData[sheet[0]];
          }else{
            this.data = [];
          }
          this.enableImportExcel = true;
        };
        reader.readAsBinaryString(target.files[0]);
      }
      else {
        this.enableImportExcel = false;
        this.errorImport = "Error al intentar abrir el archivo ! ";
      }
    } else {
      this.uploadedFileName = "Archivo a subir";
    }
  }

  checkHiddenRowAndColumns(file) {
    const workbook = new Excel.Workbook();
    const arryBuffer = new Response(file).arrayBuffer();

    arryBuffer.then((data) => {
      workbook.xlsx.load(data)
        .then(() => {
          const worksheet = workbook.getWorksheet(1);
          this.spinnerService.hide();
          var name;
          var k =0;
          //check hidden columns
          for(var i=0; i < worksheet.columns.length; i++) {
            if(worksheet.columns[i].hidden == true){
              this.hiddenColumn.push(worksheet.columns[i].letter);
              this.hiddenColumnCount++;
            }
            if(worksheet.columns[i].values.length > 0){
              name = worksheet.columns[i].values[1];
            }else{
              //for empty header
              if(k == 0) {
                name = "__EMPTY";
                k++;
              }
              else if(k > 0){
                name = "__EMPTY_"+k;
                k++;
              }
            }
            if (!name.includes("__EMPTY")) {
              this.excelColumnNameAndLetter.push(
                {
                  "letter": worksheet.columns[i].letter,
                  "name": name,
                  "hidden": worksheet.columns[i].hidden
                }
              );
            }
          }

          //check hidden row
          worksheet.eachRow((row) => {
            if(row.hidden == true) {
              this.hiddenRow.push(row.number);
              this.hiddenRowCount++;
            }
          });
         
        });
    });
  }

  import(){
    this.enableImportExcel = false;
    this.spinnerService.show();
    if(this.data.length > 100) {
    setTimeout(() => {
      this.importExcelData();
    }, 1000)
    }
    else {
      this.importExcelData();
    }
  }

  checkExcelHeader() {
    for (var i = 0; i < this.excelheaderFormat.length; i++) {
      for (var j = 0; j < this.excelHeader.length; j++) {
        if (this.excelheaderFormat[i] === this.excelHeader[j]) {
          this.excelAvailableColumn.push(this.excelheaderFormat[i]);
        }
      }
    }
    this.missingExcelColumns = this.excelheaderFormat.filter(item => this.excelAvailableColumn.indexOf(item) < 0);
    if(this.missingExcelColumns.length == 0){
      if (this.excelheaderFormat.length !== this.excelHeader.length) {
         this.excelInvalidColumn = this.excelHeader.filter(item => this.excelheaderFormat.indexOf(item) < 0);
      }
    }
  }

  getInvalidColumnLetter(){
    let tempValue;
    tempValue = this.excelColumnNameAndLetter.filter(item => this.excelInvalidColumn.some(f => f == item.name));
    tempValue.forEach(element => {
      if(element.hidden == false){
        this.excelInvalidColumnLetter.push(element.letter)
      }
    });
  }

  importExcelData() {
    this.tempExcelHeader = Object.keys(this.data[0]);
    //this.excelHeader = Object.keys(this.data[0]);
    // this.excelHeader.forEach(function(item, index, object) {
    //   if (item.includes("__EMPTY")) {
    //     object.splice(index, 1);
    //   }
    // });

    for (var x = 0; x < this.tempExcelHeader.length; x++) {
      if (!this.tempExcelHeader[x].includes("__EMPTY")) {
        this.excelHeader.push(this.tempExcelHeader[x])
      }
    }

    this.checkExcelHeader()
    this.getInvalidColumnLetter();
    if(this.excelAvailableColumn.length == 19) {
      var k=1
      this.data.forEach(element => {
        element['ITEM'] = k;
        k++
      });
    //if ((this.missingExcelColumns.length == 0) && (this.hiddenColumnCount == 0) && (this.hiddenRowCount ==0)) {
      this.data.forEach(element => {
        let mapped = Object.keys(element).reduce((item, key) => {
          item[this.keyValuesChange[key]] = element[key];
          return item;
        }, {});
        this.keyChangedData.push(mapped);
      });
     

      for (var i = 0; i < this.keyChangedData.length; i++) {
        var object_temp = this.keyChangedData[i];
        var dataError = [];
        var dataInvalidError = [];
        // for (var j = 0; j < this.excelHeader.length; j++) {
        //   object_temp[jsonObjectKeys[j]] = this.data[i][j];

        // }  //end for j
        
        if (object_temp["CLIENT_ID"] == '' || object_temp["CLIENT_ID"] == null || object_temp["CLIENT_ID"] == undefined) {
          object_temp["CLIENT_ID"] = 'Dato inválido';
          dataError.push("ID CLIENTE");
        }

        if (object_temp["DOCUMENT"] != '' && object_temp["DOCUMENT"] != null  && object_temp["DOCUMENT"] != undefined) {
          switch (object_temp["DOCUMENT"].trim()) {
            case 'DNI':
              break;
            case 'RUC':
              break;
            case 'CEX':
              break;
            case 'OTHER':
              break;
            default:
              object_temp["DOCUMENT"] = 'Dato inválido';
              dataInvalidError.push("DOCUMENTO");
          }
        }
        else {
          object_temp["DOCUMENT"] = 'Dato inválido';
          dataError.push("DOCUMENTO");
        }

        if (object_temp["DOCUMENT_NUMBER"] == '' || object_temp["DOCUMENT_NUMBER"] == null || object_temp["DOCUMENT_NUMBER"] == undefined) {
          object_temp["DOCUMENT_NUMBER"] = 'Dato inválido';
          dataError.push("NUMERO DOCUMENTO");
        }

        if (object_temp["NAME"] == '' || object_temp["NAME"] == null || object_temp["NAME"] == undefined) {
          object_temp["NAME"] = 'Dato inválido';
          dataError.push("NOMBRE");
        }

        if (object_temp["EMAIL"] != '' && object_temp["EMAIL"] != null && object_temp["EMAIL"] != undefined) {
          if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(object_temp["EMAIL"].trim()))) {
            object_temp["EMAIL"] = 'Dato inválido';
            dataInvalidError.push("EMAIL");
          }
        }
        else {
          object_temp["EMAIL"] = 'Dato inválido';
          dataError.push("EMAIL");
        }

        if (object_temp["TELEPHONE"] == '' || object_temp["TELEPHONE"] == null || object_temp["TELEPHONE"] == undefined) {
          object_temp["TELEPHONE"] = 'Dato inválido';
          dataError.push("TELEFONO");
        }

        if (object_temp["STATUS"] != '' && object_temp["STATUS"] != null && object_temp["STATUS"] != undefined) {
          switch (object_temp["STATUS"].trim()) {
            case 'ACTIVO':
              break;
            case 'INACTIVO':
              break;
            default:
              object_temp["STATUS"] = 'Dato inválido';
              dataInvalidError.push("ESTADO");
          }
        }
        else {
          object_temp["STATUS"] = 'Dato inválido';
          dataError.push("ESTADO");
        }

        if (object_temp["PAYMENT_ORDER_ID"] == '' || object_temp["PAYMENT_ORDER_ID"] == null  || object_temp["PAYMENT_ORDER_ID"] == undefined) {
          object_temp["PAYMENT_ORDER_ID"] = 'Dato inválido';
          dataError.push("ID ORDEN DE PAGO");
        }

        if (object_temp["REFERENCE"] == '' || object_temp["REFERENCE"] == null || object_temp["REFERENCE"] == undefined) {
          object_temp["REFERENCE"] = 'Dato inválido';
          dataError.push("REFERENCIA");
        }

        if (object_temp["ORDER_NAME"] == '' || object_temp["ORDER_NAME"] == null || object_temp["ORDER_NAME"] == undefined) {
          object_temp["ORDER_NAME"] = 'Dato inválido';
          dataError.push("NOMBRE ORDEN");
        }

        if (object_temp["DESCRIPTION"] == '' || object_temp["DESCRIPTION"] == null || object_temp["DESCRIPTION"] == undefined) {
          object_temp["DESCRIPTION"] = 'Dato inválido';
          dataError.push("DESCRIPCION");
        }

        if (object_temp["CURRENCY"] != '' && object_temp["CURRENCY"] != null && object_temp["CURRENCY"] != undefined) {
          switch (object_temp["CURRENCY"].trim()) {
            case 'PEN':
              break;
            case 'USD':
              break;
            default:
              object_temp["CURRENCY"] = 'Dato inválido';
              dataInvalidError.push("MONEDA");
          }
        }
        else {
          object_temp["CURRENCY"] = 'Dato inválido';
          dataError.push("MONEDA");
        }

        // if (object_temp["AMOUNT"] != '' && object_temp["AMOUNT"] != null && object_temp["AMOUNT"] != undefined) {
        //   if (isNaN(object_temp["AMOUNT"].trim())) {
        //     object_temp["AMOUNT"] = 'Dato inválido';
        //     dataInvalidError.push("MONTO");
        //   }
        // }
        // else {
        //   object_temp["AMOUNT"] = 'Dato inválido';
        //   dataError.push("MONTO");
        // }

        if (object_temp['AMOUNT'] != '' && object_temp['AMOUNT'] != null && object_temp['AMOUNT'] != undefined) {
          if (isNaN(object_temp["AMOUNT"].trim())) {
            object_temp["AMOUNT"] = 'Dato inválido';
            dataInvalidError.push("MONTO");
          } else {
            object_temp['AMOUNT'] = this.convertToDecimal(object_temp['AMOUNT'])
            if (!(/^\d+(?:\.\d{0,2})$/).test(object_temp['AMOUNT'])) {
              object_temp["AMOUNT"] = 'Dato inválido';
              dataInvalidError.push("MONTO");
            }
            
          }
        }
        else {
          object_temp["AMOUNT"] = 'Dato inválido';
          dataError.push("MONTO");
        }

        if (object_temp["VENCIMIENTO"] != '' && object_temp["VENCIMIENTO"] != null && object_temp["VENCIMIENTO"] != undefined) {
          var vencimiento = moment(object_temp["VENCIMIENTO"].trim(),this.allowedDateFormats, true);
          if (!vencimiento.isValid()) {
            //object_temp["VENCIMIENTO"] = (this.ExcelDateToJSDate(object_temp["VENCIMIENTO"]) == "Invalid Date") ? "Dato inválido" : this.ExcelDateToJSDate(object_temp["VENCIMIENTO"]);
            object_temp["VENCIMIENTO"] = "Dato inválido";
            dataInvalidError.push("VENCIMIENTO");
          }
          // else {
          //   object_temp["VENCIMIENTO"] = "Dato inválido"
          // }
        }
        else {
          object_temp["VENCIMIENTO"] = 'Dato inválido';
          dataError.push("VENCIMIENTO");
        }

        if (object_temp["EXPIRATION"] != '' && object_temp["EXPIRATION"] != null && object_temp["EXPIRATION"] != undefined) {
          var expiration = moment(object_temp["EXPIRATION"].trim(),this.allowedDateFormats, true);
          if (!expiration.isValid()) {
           // object_temp["EXPIRATION"] = (this.ExcelDateToJSDate(object_temp["EXPIRATION"]) == "Invalid Date") ? "Dato inválido" : this.ExcelDateToJSDate(object_temp["EXPIRATION"]);
           object_temp["EXPIRATION"] = "Dato inválido";
           dataInvalidError.push("EXPIRACION");
          }
          // else {
          //   object_temp["EXPIRATION"] = "Dato inválido"
          // }
        }
        else {
          object_temp["EXPIRATION"] = 'Dato inválido';
          dataError.push("EXPIRACION");
        }

        if (object_temp["BANK_CODE"] != '' && object_temp["BANK_CODE"] != null && object_temp["BANK_CODE"] != undefined) {
          if (isNaN(object_temp["BANK_CODE"])) {
            object_temp["BANK_CODE"] = 'Dato inválido';
            dataInvalidError.push("CODIGO BANCO");
          }
        }
        else {
          object_temp["BANK_CODE"] = 'Dato inválido';
          dataError.push("CODIGO BANCO");
        }

        if (object_temp["BILL"] != '' && object_temp["BILL"] != null && object_temp["BILL"] != undefined) {
          if (isNaN(object_temp["BILL"])) {
            object_temp["BILL"] = 'Dato inválido';
            dataInvalidError.push("CUENTA");
          }
        }
        else {
          object_temp["BILL"] = 'Dato inválido';
          dataError.push("CUENTA");
        }

        if (object_temp["ACCOUNT_TYPE"] != '' && object_temp["ACCOUNT_TYPE"] != null && object_temp["ACCOUNT_TYPE"] != undefined) {
          switch (object_temp["ACCOUNT_TYPE"].trim()) {
            case 'AHORRO':
              break;
            case 'CORRIENTE':
              break;
            default:
              object_temp["ACCOUNT_TYPE"] = 'Dato inválido';
              dataInvalidError.push("TIPO DE CUENTA");
          }
        }
        else {
          object_temp["ACCOUNT_TYPE"] = 'Dato inválido';
          dataError.push("TIPO DE CUENTA");
        }

        if (isNaN(object_temp["CCI"])) {
          if(object_temp["CCI"] != null || object_temp["CCI"] != undefined){
            object_temp["CCI"] = 'Dato inválido';
            dataInvalidError.push("CCI");
           // dataError = dataError + "La celda ID CLIENTE está vacía & "
          }
        }
        if(dataError.length > 0 && dataError.length < 17){
          this.columnErrorCount++;
        }

        if(dataError.length > 17){
          this.rowErrorCount++;
        }

        if(dataInvalidError.length > 0){
          this.columnErrorCount++;
        }

        object_temp["DATAERROR"] = dataError.length > 17 ? null: dataError;
        object_temp["DATAINVALIDERROR"] = dataInvalidError;
        object_temp["ROWERROR"] = dataError.length > 17 ? dataError: null;
        this.arrFinalData.push(object_temp);
        // }
      }//end for i
      this.checkValidAndInvalidData();
      this.excelRowsFetchedCount = this.arrFinalData.length;
      this.dataSource.paginator = this.kashioPaginator;
      this.dataSource.data = this.arrFinalData;
      this.invalidDataSource.data = this.invalidDataArray;
      this.invalidDataSource.paginator = this.kashioPaginator1;
      this.obsInvalidData = this.invalidDataSource.connect();
      this.tab2();
      this.spinnerService.hide();
    }
    else {
      this.tab3Error = true;
      this.isExcelReadError = true;
      this.tab3();
      this.spinnerService.hide();
    }
  }

  convertToDecimal(value) { 
    var n = Number.parseFloat(value);
    if(!value || isNaN(n) || n < 0) return 0;
    return n.toFixed(2);
  }
  ngOnDestroy() {
    if (this.invalidDataSource) { 
      this.invalidDataSource.disconnect(); 
    }
  }

  checkValidAndInvalidData() {
    for (var i = 0; i <= this.arrFinalData.length - 1; i++) {
      var debtorobj = this.arrFinalData[i];
      var exists = Object.keys(debtorobj).some(function (k) {
        return debtorobj[k] === "Dato inválido";
      });
      if (exists == true) {
        this.invalidData(debtorobj);
      } else if (exists == false) {
        this.validData(debtorobj);
      }
    }
  }

  invalidData(data) {
    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.invalidDataArray.push(data);
  }
  validData(data) {
    this.excelRowsProcessedCount = this.excelRowsProcessedCount + 1;
  }

  confirmData({ value }: { value: AccountImport }) {
    this.spinnerService.show();
    var json_data: any = { "user": { "id": `${this.user_public_id}`, "name": `${this.userNameProcess}`, "email": `${this.userEmail}` }, "company": { "id": `${this.customerPuplic_key}`, "name": `${this.userNameProcess}` } };

    if ((value.edt.name.includes(".xlsx") || value.edt.name.includes(".xls")) && (value.edt.type == ".xlsx" || value.edt.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || value.edt.type == "application/vnd.ms-excel")) {
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "application/vnd.ms-excel" }), this.uploadedFileName);
    }

    this.formData.append('description', "EDT FILE");
    this.formData.append('customer_id', this.customerPuplic_key);
    this.formData.append('template_id', this.templateName);
    this.formData.append('metadata', JSON.stringify(json_data))
    this.processservice.ProcessImport(this.formData).subscribe(val => {
      this.parseID = val.body.id;
      if (val.status == '202') {
        this.importConfirm();
      }
      else {
        this.tab3Error = true;
        this.tab3();
      }
    },
      err => {
        this.tab3Error = true;
        this.tab3();
        console.log('Failed! while trying import. ' + err);
      });
  }

  importConfirm() {
    this.processservice.ProcessImportParse(this.parseID).subscribe(val => {
      if (val == 200) {
        this.tab3();
        this.spinnerService.hide();
      } 
      else {
        this.tab3();
        this.spinnerService.hide();
      }
    },
      err => {
        this.tab3Error = true;
        this.tab3();
        console.log('Failed! while trying import confirm. ' + err);
        this.spinnerService.hide();
      });
  }

  downloadResultAsXLSX() {
    this.setExportExcelFileData(this.arrFinalData);
  }

  setExportExcelFileData(excelExportData) {
    var excelHeaders = ["ITEM","ID CLIENTE", "DOCUMENTO", "NUMERO DOCUMENTO", "NOMBRE", "EMAIL", "TELEFONO", "ESTADO", "ID ORDEN DE PAGO",
    "REFERENCIA", "NOMBRE ORDEN", "DESCRIPCION", "MONEDA", "MONTO", "VENCIMIENTO", "EXPIRACION", "CODIGO BANCO", "CUENTA", "TIPO DE CUENTA", "CCI"];
    var arrFinalDatas = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];
    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      columnsKeyNames = Object.keys(singleRec_temp);
      var client_id_temp = "";
      var document_temp = "";
      var document_number_temp = "";
      var name_temp = "";
      var email_temp = "";
      var telephone_temp = "";
      var status_temp = "";
      var payment_order_id_temp = "";
      var reference_temp = "";
      var order_name_temp = "";
      var description_temp = "";
      var currency_temp = "";
      var amount_temp = "";
      var vencimiento_temp = "";
      var expiration_temp = "";
      var bank_code_temp = "";
      var bill_temp = "";
      var account_type_temp = "";
      var item_temp = ""
      object_temp = {};
      for (var j = 0; j < columnsKeyNames.length; j++) {
        if (columnsKeyNames[j] == "ITEM") {
          item_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "CLIENT_ID") {
          client_id_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "DOCUMENT") {
          document_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "DOCUMENT_NUMBER") {
          document_number_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "NAME") {
          name_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "EMAIL") {
          email_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "TELEPHONE") {
          telephone_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "STATUS") {
          status_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "PAYMENT_ORDER_ID") {
          payment_order_id_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "REFERENCE") {
          reference_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "ORDER_NAME") {
          order_name_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "DESCRIPTION") {
          description_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "CURRENCY") {
          currency_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "AMOUNT") {
          amount_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "VENCIMIENTO") {
          var duedate = moment(singleRec_temp[columnsKeyNames[j]]);

          if (duedate.isValid()) {
            //var datedue = this.ExcelDateToJSDate(singleRec_temp[columnsKeyNames[j]]);

            var momentObj = moment(singleRec_temp[columnsKeyNames[j]]);

            var momentStringDue = momentObj.format('DD/MM/YYYY');

            vencimiento_temp = momentStringDue;
          }
          else {

            vencimiento_temp = singleRec_temp[columnsKeyNames[j]];
          }

        }
        else if (columnsKeyNames[j] == "EXPIRATION") {
          var expdate = moment(singleRec_temp[columnsKeyNames[j]]);

          if (expdate.isValid()) {
            //var datedue = this.ExcelDateToJSDate(singleRec_temp[columnsKeyNames[j]]);

            var momentObj = moment(singleRec_temp[columnsKeyNames[j]]);

            var momentStringDue = momentObj.format('DD/MM/YYYY');

            expiration_temp = momentStringDue;
          }
          else {

            expiration_temp = singleRec_temp[columnsKeyNames[j]];
          }
        }
        else if (columnsKeyNames[j] == "BANK_CODE") {
          bank_code_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "BILL") {
          bill_temp = singleRec_temp[columnsKeyNames[j]];
        }
        else if (columnsKeyNames[j] == "ACCOUNT_TYPE") {
          account_type_temp = singleRec_temp[columnsKeyNames[j]];
        }
        // else if (columnsKeyNames[j] == "PROCESS_STATUS_TEXT") {
        //   process_status_txt_temp = singleRec_temp[columnsKeyNames[j]];
        // }
      }
      arrFinalDatas.push([item_temp,client_id_temp,document_temp,document_number_temp,name_temp,email_temp,
        telephone_temp,status_temp,payment_order_id_temp,reference_temp,order_name_temp,description_temp,currency_temp
      ,amount_temp,vencimiento_temp,expiration_temp,bank_code_temp,bill_temp,account_type_temp])
    }
    //this.excelService.exportAsExcelFile(arrFinalDatas, 'Payout process Import');
    this.excelService.generateExcelForPayoutImportError(excelHeaders,arrFinalDatas)
  }
}
